import { createFileRoute } from '@tanstack/react-router';
import AuthError from 'src/features/auth/components/AuthError';

export const Route = createFileRoute('/_auth/auth-error')({
  head: () => ({
    meta: [{ title: 'Auth Error | Tekst' }],
  }),
  component: AuthErrorPage,
});

function AuthErrorPage() {
  return <AuthError redirectUrl="/login" />;
}
